<template>
    <span v-if="showValue">{{ value }}</span>
</template>

<script>
export default {
    name: "AsyncText",
    props: {
        value: {
            type: [String, Number],
            required: true
        },
    },
    data() {
        return {
            showValue: false,
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.showValue = true;
        });
    },
}
</script>